import styled from 'styled-components'
import React, {useContext} from 'react'
import AppContext from '../../context'
import {media} from '../../theme/config'

const AccountFlyout = styled.div`
  display: ${({showFlyout}) => { return showFlyout ? 'flex' : 'none' }};
  flex-direction: column;
  position: absolute;
  width: 100%;
  right: 0;
  top: 56px;
  z-index: 3;
  box-shadow: 0 6px 25px -6px rgba(78,95,116,0.5);
  text-align: center;
  border-bottom: 3px solid ${props => props.theme.colors.primary.base};
  
  a {
    padding: 12px 20px;
    background-color: ${props => props.theme.colors.greyscale.white};
    z-index: 2;
    overflow: hidden;
    
    &:first-child {
      border-radius: 6px 6px 0 0;
    }
    
    &:last-child {
      border-radius: 0 0 6px 6px;
    }
    
    &:not(:last-child) {
      border-bottom: 1px solid ${props => props.theme.colors.greyscale.light};
    }
  }

  &:before {
    background-color: ${props => props.theme.colors.greyscale.white};
    z-index: 1;
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    top: 4px;
    transform: translateY(-50%) rotate(45deg);
    box-shadow: -1px -1px 10px 0 rgba(0,0,0,.2);
    display: block;
    right: ${({showCart}) => (showCart ? '80px' : '29px')};
  }

  @media ${media.mobileL} {
    text-align: left;
    border-bottom: none;
    border-radius: 6px;
    right: 15px;
    top: 35px;
    min-width: 240px;
    
    &:before {
      right: 20px;
    }
  }
`

const AccountLink = styled.a`
  color: ${props => props.theme.colors.greyscale.black};
  font-size: ${({theme}) => theme.typography.fontSize.fs3};
  line-height:  ${({theme}) => theme.typography.lineHeight.fs3};
  font-weight: normal;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    color: ${props => props.theme.colors.primary.dark};
    background: ${props => props.theme.colors.greyscale.subtle};
  }
`

export default (props) => {
  const {translations, hasReorder, bonuspointsAvailable, reorderLink} = useContext(AppContext)

  const accountOverview = {href: '/account/overview', text: translations.get('shop.header.account.overview')}
  const orders = {href: '/account/orders/overview', text: translations.get('shop.header.account.orderoverview')}
  const reorder = {href: reorderLink, text: translations.get('shop.header.account.reorder')}
  const bonuspoints = {href: '/account/bonuspoints/products/overview', text: translations.get('shop.header.account.bonusprogram')}

  const accountLinks = []
  accountLinks.push(accountOverview)
  accountLinks.push(orders)
  if (hasReorder) accountLinks.push(reorder)
  if (bonuspointsAvailable) accountLinks.push(bonuspoints)

  return (
    <AccountFlyout {...props}>
      {accountLinks.map((link, i) => (
        <AccountLink
          href={link.href}
          key={i}
          role="menuitem"
        >
          {link.text}
        </AccountLink>
      ))}
    </AccountFlyout>
  )
}
